import { render, staticRenderFns } from "./BaseLoader.vue?vue&type=template&id=ca7bdb50&functional=true&"
import script from "./BaseLoader.vue?vue&type=script&lang=js&"
export * from "./BaseLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports